import * as React from 'react'
import {ReactElement} from 'react'
import {Box, CardActionArea} from '@mui/material'
import {Colors} from '../../../../styledComponents/Constants'
import {currentMedia} from '../../../../styledComponents/ResponsiveConvenience'
import {forwardArrow} from '../../../../styledComponents/Links'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import styled from 'styled-components'
import {Assoc} from '../repository/NatGetAssocInfos'
import {StyledPageTitle} from '../../../../components/reservations/components/CommonStyle'
import {NatAssocWorkReportRepo} from '../repository/NatAssocWorkReportRepo'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    assocWorkReportRepo: NatAssocWorkReportRepo
    location: Location
}

interface State {
    assocInfos: Assoc[]
    isLoadCompleted: boolean
}

class NatResidentAssociationSelectionPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            assocInfos: [],
            isLoadCompleted: false,
        }
    }

    async componentDidMount(): Promise<void> {
        const {eventEmitter} = this.props

        await eventEmitter.showLoading()
        try {
            const assocInfosResponse = await this.getAssocInfo()
            if (assocInfosResponse.length === 1) {
                const assocCd = assocInfosResponse[0].assocCd
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/assocs/${assocCd}/work-Report`,
                    {replace: true}
                )
            }
            this.setState({assocInfos: assocInfosResponse})
        } finally {
            await eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async getAssocInfo(): Promise<Assoc[]> {
        const {condominiumCd, assocWorkReportRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            assocWorkReportRepo.getAssocs.bind(assocWorkReportRepo, condominiumCd),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response?.details ? response.details.assocList : []
    }

    handleAssocMenuClick(assocCd: string): void {
        this.props.navigate(`/resident/condominiums/${this.props.condominiumCd}/assocs/${assocCd}/work-Report`)
    }

    renderAssociationName(): ReactElement {
        const {assocInfos} = this.state
        return (
            <>
                {
                    assocInfos
                        .map((assocInfo) =>
                            <AssocMenu key={assocInfo.assocCd} onClick={() => {
                                this.handleAssocMenuClick(assocInfo.assocCd)
                            }}>
                                <MenuContainer>
                                    <MenuItemName>{assocInfo.assocName}</MenuItemName>
                                </MenuContainer>
                            </AssocMenu>,
                        )}
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                <StyledPageTitle>
                    管理組合選択
                </StyledPageTitle>
                <Box height={'20px'}/>
                {this.renderAssociationName()}
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentAssociationSelectionPage)

const AssocMenu = styled(CardActionArea)`
  &.MuiCardActionArea-root {
    width: 100%;
    max-width: 738px;
    height: 100%;
    min-height: 54px;
    color: ${Colors.Body};
    background-color: ${Colors.Surface};
    line-height: 24px;
    padding: 15px 0;
    margin: 0 auto 2px auto;
    ${currentMedia.lessThan('sp')`
      width: calc(100% + 30px);
      margin: 0 -15px 1px -15px
  `};
  }
`

const MenuContainer = styled.div`
  display: flex;
  margin: 0 15px;
  align-items: center;
`

const MenuItemName = styled.div`
  flex-grow: 1;
  text-align: start;
  position: relative;
  padding-right: 15px;
  overflow-wrap: anywhere;

  :after {
    ${forwardArrow};
    border-top: solid 1px ${Colors.AccentDark};
    border-right: solid 1px ${Colors.AccentDark};
  }
`
